let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hNOP2")).then(() => parcelRequire('c3ssB'));